import React from 'react';

function EmptyTodos() {
  return (
    <p>Sin tareas por el momento. 🥂</p>
  );
}

export { EmptyTodos };